import { Box, Typography, useTheme } from '@mui/material';
import { useWaterData } from 'src/hooks/featureHooks';
import { AssetType } from 'src/features/sites/types/types';

type Props = {
  asset: AssetType | undefined;
};

export const WetWellWidget = ({ asset }: Props) => {
  const { waterLevel, unit, height: eneteredHeight } = useWaterData({ asset });
  const theme = useTheme();

  const widthOfElement = 50;
  const heightOfElement = 90;
  const tankHeight = heightOfElement * 0.99;

  const waterHeightPx = ((waterLevel ?? 0) / eneteredHeight!) * tankHeight;

  const labelBottom = Math.min(waterHeightPx, tankHeight - 58);

  const waterLevelPercentage = (waterLevel! / eneteredHeight!) * 100;
  return (
    <Box
      data-sm="wet-well-widget"
      sx={{
        position: 'relative',
        width: widthOfElement,
        height: heightOfElement,
        border: `0.1px solid ${theme.palette.grey[400]}`,
        background: '#f4f4f7',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: `${(heightOfElement * waterLevelPercentage) / 100}px`,
          backgroundColor: '#cbdef7',
          transition: 'height 0.3s ease',
        }}
      />

      {waterLevel !== null && (
        <Typography
          variant="caption"
          data-sm="well-value"
          sx={{
            position: 'absolute',
            bottom: `${labelBottom}px`,
            left: '50%',
            transform: 'translateX(-50%)',
            fontWeight: 500,
            fontSize: '10px',
            px: 0.5,
            borderRadius: 1,
            textAlign: 'center',
          }}
        >
          {waterLevel} {unit}
        </Typography>
      )}
    </Box>
  );
};
